var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSurveyIconIncreaseAutomationTestCoverage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 12.5H1.5V.75A.76.76 0 0 0 .75 0 .74.74 0 0 0 0 .75V13c0 .563.438 1 1 1h14.25a.74.74 0 0 0 .75-.75.76.76 0 0 0-.75-.75zM4.5 8.531l2-1.969 2.469 2.47c.125.155.312.218.531.218a.622.622 0 0 0 .5-.219l3.5-3.469V7.25c0 .438.313.75.75.75a.74.74 0 0 0 .75-.75v-3.5a.76.76 0 0 0-.75-.75h-3.5a.74.74 0 0 0-.75.75c0 .438.313.75.75.75h1.688L9.5 7.469 7 4.969c-.313-.282-.781-.282-1.063 0l-2.5 2.5c-.312.312-.312.781 0 1.062a.72.72 0 0 0 1.063 0z",
    fill: "#233145"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyIconIncreaseAutomationTestCoverage);
export default __webpack_public_path__ + "static/media/survey-icon-increase-automation-test-coverage.00003c551a643f0eeb7024e975767b8a.svg";
export { ForwardRef as ReactComponent };